import './resources/styles.css';
import { Element } from 'react-scroll';

import Header from './components/header_footer/Header';
import Featured from './components/featured';
import VenueNfo from './components/venueNfo';
import Highlight from './components/Highlights';
import Pricing from './components/pricing';
import Location from './components/location';
import Footer from './components/header_footer/Footer';

const App = () => {
	return (
		<div className='App'>
			<Header />
			<Element name='featured'>
				<Featured />
			</Element>
			<Element name='venueNfo'>
				<VenueNfo />
			</Element>
			<Element name='highlights'>
				<Highlight />
			</Element>

			<Element name='pricing'>
				<Pricing />
			</Element>

			<Element name='location'>
				<Location />
			</Element>
			<Footer />
		</div>
	);
};

export default App;
